import { Box, Button, FormControlLabel, Switch } from "@mui/material";
import { AreaEntranceCheck, GetAreaColor } from "./EntranceCheck";
import { groupBy, isNil, orderBy, sortBy } from "lodash";
import { useState } from "react";
import { Grottos, Interiors, MixPoolPlace, MixpoolType, OverworldEntrances } from "./MixPoolNotes";
import { SimpleMinuet } from "../inventory/songs/MinuetOfForest";
import { SimpleBolero } from "../inventory/songs/BoleroOfFire";
import { SimpleSerenade } from "../inventory/songs/SerenadeOfWater";
import { SimpleNocturne } from "../inventory/songs/NocturneOfShadow";
import { SimpleRequiem } from "../inventory/songs/RequiemOfSpirit";
import { SimplePrelude } from "../inventory/songs/PreludeOfLight";
import { SimpleKokiriSwordItem } from "../inventory/items/KokiriSwordItem";
import { SimpleMasterSwordItem } from "../inventory/items/MasterSwordItem";
import { SimpleOwlDmt } from "../inventory/items/OwlDmtSimple";
import { SimpleOwlLH } from "../inventory/items/SimpleOwlLake";
import TrackLocationEntrance from "./TrackLocationEntrance";
import { SimpleGhoma } from "../inventory/bosses/SimpleGhoma";
import { SimpleKD } from "../inventory/bosses/SimpleKD";
import { SimpleBarinade } from "../inventory/bosses/SimpleBarinade";
import { SimplePG } from "../inventory/bosses/SimplePG";
import { SimpleVolvagia } from "../inventory/bosses/SimpleVolvagia";
import { SimpleMorpha } from "../inventory/bosses/SimpleMorpha";
import { SimpleTwinrova } from "../inventory/bosses/SimpleTwinrova";
import { SimpleGanondorf } from "../inventory/bosses/SimpleGanondorf";
import { SimpleBongo } from "../inventory/bosses/SimpleBongo";
import { resetMixedPool, setVanillaWarpLogic } from "../OotrReducer";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { useDispatch } from "react-redux";
import ToT from "../../core/assets/oot/classic/OoT_Pedestal_of_the_Master_Sword_Model.png";
import Bowling from "../../core/assets/oot/classic/OoT_Bombchu_Bowling_Alley_Operator_Model.png";
import Windmill from "../../core/assets/oot/classic/OoT_Phonogram_Man_Model.png";
import Fishing from "../../core/assets/oot/classic/Fish_icon.svg.png";
import Token from "../../core/assets/oot/gshd/collected-skulltulas_32x32.png";
import BigPoe from "../../core/assets/oot/gshd/bottle-big-poe_32x32.png";
import Dampe from "../../core/assets/oot/classic/OoT_Dampé_Model.png";
import Sun from "../../core/assets/oot/gshd/suns-song_32x32.png";
import Bow from "../../core/assets/oot/gshd/bow_32x32.png";
import Slingshot from "../../core/assets/oot/gshd/slingshot_32x32.png";
import MaskOfTruth from "../../core/assets/oot/gshd/mask-of-truth_32x32.png";
import SkullMask from "../../core/assets/oot/gshd/skull-mask_32x32.png";
import Lens from "../../core/assets/oot/gshd/lens_32x32.png";
import GenericModal from "../../core/components/base/GenericModal";
import BaseAutocomplete from "../../core/components/base/BaseAutocomplete";
import { findAllPaths, PathResult } from "./EntranceHelper";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

interface EntranceTrackerProps {
  displayImportantInterrior?: boolean;
  displayOverworldEntrance?: boolean;
  dungeons?: boolean,
  dungeonExits?: boolean,
  interrior?: boolean,
  grottos?: boolean
  overworld?: boolean
  widthEnhanced?: boolean
}

const EntranceTracker = (props: EntranceTrackerProps) => {

  let [hideDoneArea, setHideDoneArea] = useState(false);
  let [hideEntrancesLeft, setHideEntranceLeft] = useState(false);
  let [highlightAreaAccess, setHighlightAreaAccess] = useState<string>("");

  let [opentPathingModal, setOpenPathingModal] = useState(false);
  let [startPathing, setStartPathing] = useState<string | null>(null);
  let [endPathing, setEndPathing] = useState<string | null>(null);
  let [paths, setPaths] = useState<PathResult[]>([]);

  let vanillaWarpLogic = useSelector((state: AppState) => state.ui.ootr.main.vanillaWarpLogic)
  let entrances = useSelector(
    (state: AppState) => state.ui.ootr.main.entrances
  );
  // let startingLocations = useSelector(
  //     (state: AppState) => state.ui.ootr.main.accessibleStartingLocation
  // );

let dispatch = useDispatch();
  let grottosEntrance: Array<MixPoolPlace> = []
  let mixpoolTypes: Array<MixpoolType> = [];

 if(!props.dungeons && !props.grottos && !props.interrior && !props.overworld)
  return <></>
  
  if(isNil(props.grottos) || props.grottos){
    grottosEntrance = [...grottosEntrance, ...Grottos];
    mixpoolTypes = [...mixpoolTypes, "grotto"];
  }
  if(isNil(props.interrior) || props.interrior){
    grottosEntrance = [...grottosEntrance, ...Interiors];
    mixpoolTypes = [...mixpoolTypes, "interior"];
  }
  if(isNil(props.overworld) || props.overworld){
    grottosEntrance = [...grottosEntrance, ...OverworldEntrances.filter(x => x.type !== "dungeon_entrance" && x.type !== "dungeon")];
    mixpoolTypes = [...mixpoolTypes, "overworld"];
  }
  if(isNil(props.dungeonExits) || props.dungeonExits){
    grottosEntrance = [...grottosEntrance, ...OverworldEntrances.filter(x =>  x.type === "dungeon")];
    mixpoolTypes = [...mixpoolTypes, "dungeon"];
  }

  grottosEntrance = sortBy(grottosEntrance, ["globalArea"], ["asc"])
  

  let dungeons = [...OverworldEntrances.filter(x => x.type === "dungeon_entrance")]

  dungeons = sortBy(dungeons, "order", "asc")

  if((!isNil(props.dungeons) && !props.dungeons) || isNil(props.dungeons))
    dungeons = [];
  else
    mixpoolTypes = [...mixpoolTypes, "dungeon_entrance"];


  dungeons.forEach(x => grottosEntrance.push(x))
  
  let dic = groupBy(grottosEntrance, (x) => x.zone);

  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Box display={"flex"} flexDirection={"row"}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          sx={{
            overflow: "scroll",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
          maxHeight={1680}
        >
          <Box display={"flex"} flexDirection={"row"}>
            <FormControlLabel
              control={
                <Switch
                  checked={hideDoneArea}
                  onChange={(e, v) => setHideDoneArea(v)}
                />
              }
              label="Hide done area"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={hideEntrancesLeft}
                  onChange={(e, v) => setHideEntranceLeft(v)}
                />
              }
              label="Hide entrance left"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={vanillaWarpLogic}
                  onChange={(e, v) => dispatch(setVanillaWarpLogic(v))}
                />
              }
              label="Entrance display vanilla warp taken"
            />
            <Button onClick={() => {dispatch(resetMixedPool())}}>Reset</Button>
            <Box display={"flex"} flexWrap={"wrap"}>
              <SimpleMinuet />
              <SimpleBolero />
              <SimpleSerenade />
              <SimpleNocturne />
              <SimpleRequiem />
              <SimplePrelude />
              <SimpleKokiriSwordItem />
              <SimpleMasterSwordItem />
              <SimpleOwlDmt />
              <SimpleOwlLH />
              <SimpleGhoma />
              <SimpleKD />
              <SimpleBarinade />
              <SimplePG />
              <SimpleVolvagia />
              <SimpleMorpha />
              <SimpleBongo />
              <SimpleTwinrova />
              <SimpleGanondorf />
              <Button onClick={() => setOpenPathingModal(true)}>Pathing</Button>
              <GenericModal open={opentPathingModal} handleClose={(v)=> setOpenPathingModal(false)} width={1300}>
                <BaseAutocomplete<string | null, false> label="Start" options={Object.keys(dic)} onChange={(e, v) => setStartPathing(v)} value={startPathing}></BaseAutocomplete>
                <BaseAutocomplete<string | null, false> label="End" options={Object.keys(dic)} onChange={(e, v) => setEndPathing(v)} value={endPathing}></BaseAutocomplete>
                <Button onClick={() => setPaths(orderBy(findAllPaths(Object.values(entrances).flatMap(x => x), startPathing, endPathing), "era"))}>Generate Paths</Button>
                <Box display={"flex"} flexDirection={"column"}>
                  <Box><h2>Both</h2></Box>
                {paths.filter(x => x.era === "both").map(x => {
                  return <Box display={"flex"} flexDirection={"row"} width={"100%"}>{x.paths.map((subPath, i) => {
                      return <SubPathDisplay exit={subPath.exit} era={subPath.era} isLast={i === x.paths.length - 1 } nbExitsNotVisited={subPath.exitNotVisited} />
                  })}</Box>
                })}
                <Box><h2>Child</h2></Box>
                {paths.filter(x => x.era === "child").map(x => {
                  return <Box display={"flex"} flexDirection={"row"} width={"100%"}>{x.paths.map((subPath, i) => {
                      return  <SubPathDisplay exit={subPath.exit} era={subPath.era} isLast={i === x.paths.length - 1}  nbExitsNotVisited={subPath.exitNotVisited} />
                  })}</Box>
                })}
                <Box><h2>Adult</h2></Box>
                {paths.filter(x => x.era === "adult").map(x => {
                  return <Box display={"flex"} flexDirection={"row"} width={"100%"}>{x.paths.map((subPath, i) => {
                      return  <SubPathDisplay exit={subPath.exit} era={subPath.era} isLast={i === x.paths.length - 1}  nbExitsNotVisited={subPath.exitNotVisited} />
                  })}</Box>
                })}
                </Box>
              </GenericModal>
            </Box>
          </Box>
          {/* <Box display={"flex"} flexDirection={"column"} maxHeight={"550px"} flexWrap={"wrap"}> */}
          {Object.keys(dic).map((k, v) => {
            return (
              <AreaEntranceCheck
                widthEnhanced={props.widthEnhanced}
                areaName={k}
                values={dic}
                hideAreaDone={hideDoneArea}
                hideEntranceLeft={hideEntrancesLeft}
                areaToDisplay={mixpoolTypes}
                highlightAreaAccess={highlightAreaAccess}
                setHighlightAreaAccesss={setHighlightAreaAccess}
              />
            );
          })}
        </Box>
        {/* </Box> */}
        <Box
          display={"flex"}
          flexDirection={"column"}
          flexWrap={"wrap"}
          maxHeight={1000}
        >
          {(props.displayImportantInterrior ||
            isNil(props.displayImportantInterrior)) && (
            <Box display={"flex"} flexDirection={"column"} marginTop="35px">
              <Box fontWeight={"bold"}>Major Interriors</Box>
              <TrackLocationEntrance label="ToT" img={ToT}  />
              <TrackLocationEntrance label="Bowling" img={Bowling} />
              <TrackLocationEntrance label="Windmill" img={Windmill} />
              <TrackLocationEntrance label="Fishing" img={Fishing} />
              <TrackLocationEntrance label="Skull_House" img={Token} />
              <TrackLocationEntrance label="Poe_Pot" img={BigPoe} />
              <TrackLocationEntrance label="Dampe_Race" img={Dampe} />
              <TrackLocationEntrance label="Dampe_Hut" img={Dampe} />
              <TrackLocationEntrance label="Sun_Grave" img={Sun} />
              <TrackLocationEntrance label="Royal_Tomb"  />
              <TrackLocationEntrance label="Bowling"  />
              <TrackLocationEntrance label="Lab" />
              <TrackLocationEntrance label="Theater" img={SkullMask}/>
              <TrackLocationEntrance label="Tektike" />
              <TrackLocationEntrance label="Slingshot" img={Slingshot} />
              <TrackLocationEntrance label="Archery" img={Bow} />
              <TrackLocationEntrance label="CMG" img={Lens} />
              <TrackLocationEntrance label="Mask_Shop" img={MaskOfTruth}/>
              <TrackLocationEntrance label="Talon" />
              <TrackLocationEntrance label="Silo" />
              <TrackLocationEntrance label="Shop" />
              <TrackLocationEntrance label="1 Scrubs" />
              <TrackLocationEntrance label="2 Scrubs" />
              <TrackLocationEntrance label="3 Scrubs" />
              <TrackLocationEntrance label="Generic" />
              <TrackLocationEntrance label="Great Fairy" />
            </Box>
          )}
        </Box>
      </Box>
      {/* <Box display={"flex"}>
        <EntrancePathing />

      </Box> */}
    </Box>
  );
};

export default EntranceTracker;


interface SubPathDisplayProps {
  exit: string,
  era: "child" | "adult" | "both",
  isLast: boolean,
  nbExitsNotVisited: number
}
const SubPathDisplay = (props: SubPathDisplayProps) => {

  let color = GetAreaColor(props.exit.split(" ")[0])

  let exitParsing = props.exit.split(" => ");
  if(exitParsing.length !== 2)
    exitParsing = props.exit.split(" ");

  return <Box display={"flex"} flexDirection={"row"}> 
            <Box display={"flex"} flexDirection={"column"}>
                <Box display={"flex"} alignItems={"center"} sx={{color: color}} marginRight={"10px"}><Box fontSize={"20px"} fontWeight={"bold"} marginRight={"5px"}>{exitParsing[0]}</Box> ({exitParsing[1]}) ({props.nbExitsNotVisited})</Box>
                <Box height={"32px"}> {props.era === "child" ? <SimpleKokiriSwordItem /> : props.era === "adult" ? <SimpleMasterSwordItem /> : ""} </Box>
            </Box>
            {!props.isLast ? <Box  marginRight={"10px"}>
              <ArrowRightAltIcon fontSize={"large"} />
            </Box>: null}
            </Box>
}
